import { createRequestAction, createAction } from '../../Helpers/Action.helpers';
import { IMPORT_ACTIONS, STATUS } from '../../Constants/Actions.constants';
import { routeReplacer, createQueriedURL } from '../../Helpers/String.helper';
import { IMPORT_URLS } from '../../Constants/Urls.constants';
import { IImport } from '../../Models/DTO/Import.model';
import { IImportFile } from '../../Models/DTO/ImportFile.model';

export const requestImportById = (id: string, providerId: string) =>
  createRequestAction({
    name: IMPORT_ACTIONS.GET_IMPORT,
    url: createQueriedURL(routeReplacer(IMPORT_URLS.IMPORT_ID, { id }), { providerId }),
    method: 'GET',
  });

export const requestCreateNewImport = (providerId: string) =>
  createRequestAction<IImport>({
    name: IMPORT_ACTIONS.POST_IMPORT,
    url: createQueriedURL(IMPORT_URLS.IMPORT, { providerId }),
    method: 'POST',
  });

export const requestImportFileUpload = (id: string, providerId: string, file: FormData) =>
  createRequestAction<IImportFile>({
    name: IMPORT_ACTIONS.POST_IMPORT_FILE,
    url: createQueriedURL(routeReplacer(IMPORT_URLS.IMPORT_FILE, { id }), { providerId }),
    method: 'POST',
    data: file,
  });

export const requestImportList = (providerId: string) =>
  createRequestAction<IImport[]>({
    name: IMPORT_ACTIONS.GET_IMPORT_LIST,
    url: createQueriedURL(IMPORT_URLS.IMPORT, { providerId, page: 0, limit: 5 }),
  });

export const requestSetCurrentImport = (currentImport: IImport) =>
  createAction({
    type: IMPORT_ACTIONS.GET_IMPORT,
    name: IMPORT_ACTIONS.GET_IMPORT,
    status: STATUS.SUCCESS,
    payload: currentImport,
  });
